import 'react-perfect-scrollbar/dist/css/styles.css';

import React from 'react';

import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { TCustomScrollbarProps } from './CustomScrollbar.types';


export const CustomScrollbar: React.FC<TCustomScrollbarProps> = ({
  className,
  children,
  component,
  containerRef,
  onScroll,
  onScrollY,
}) => {
  return (
    <PerfectScrollbar
      className={classnames('js-custom-scrollbar', className)}
      component={component}
      containerRef={containerRef}
      onScroll={onScroll}
      onScrollY={onScrollY}>
      {children}
    </PerfectScrollbar>
  );
};
